/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as LSecretRouteImport } from './routes/l.$secret'
import { Route as ChatTokenRouteImport } from './routes/chat.$token'
import { Route as AdminReglagesRouteImport } from './routes/admin/reglages'
import { Route as AdminProdRouteImport } from './routes/admin/prod'
import { Route as AdminMediathequeRouteImport } from './routes/admin/mediatheque'
import { Route as AdminJournalRouteImport } from './routes/admin/journal'
import { Route as AdminSessionsIndexRouteImport } from './routes/admin/sessions.index'
import { Route as AdminReglagesIndexRouteImport } from './routes/admin/reglages.index'
import { Route as AdminProtocolesIndexRouteImport } from './routes/admin/protocoles.index'
import { Route as AdminPersonasIndexRouteImport } from './routes/admin/personas.index'
import { Route as AdminExperiencesIndexRouteImport } from './routes/admin/experiences.index'
import { Route as AdminEntretiensIndexRouteImport } from './routes/admin/entretiens.index'
import { Route as AdminCriteresIndexRouteImport } from './routes/admin/criteres.index'
import { Route as AdminSessionsSessionIdRouteImport } from './routes/admin/sessions.$sessionId'
import { Route as AdminReglagesRejeuRouteImport } from './routes/admin/reglages.rejeu'
import { Route as AdminReglagesReglesRouteImport } from './routes/admin/reglages.regles'
import { Route as AdminReglagesPersonasRouteImport } from './routes/admin/reglages.personas'
import { Route as AdminReglagesPartageRouteImport } from './routes/admin/reglages.partage'
import { Route as AdminReglagesNoyauxRouteImport } from './routes/admin/reglages.noyaux'
import { Route as AdminReglagesModelesRouteImport } from './routes/admin/reglages.modeles'
import { Route as AdminReglagesMethodeRouteImport } from './routes/admin/reglages.methode'
import { Route as AdminReglagesJetonsRouteImport } from './routes/admin/reglages.jetons'
import { Route as AdminProtocolesNouveauRouteImport } from './routes/admin/protocoles.nouveau'
import { Route as AdminProtocolesProtocolIdRouteImport } from './routes/admin/protocoles.$protocolId'
import { Route as AdminPersonasNouveauRouteImport } from './routes/admin/personas.nouveau'
import { Route as AdminPersonasPersonaIdRouteImport } from './routes/admin/personas.$personaId'
import { Route as AdminExperiencesNouveauRouteImport } from './routes/admin/experiences.nouveau'
import { Route as AdminExperiencesExperienceIdRouteImport } from './routes/admin/experiences.$experienceId'
import { Route as AdminEntretiensRoomIdRouteImport } from './routes/admin/entretiens.$roomId'
import { Route as AdminCriteresNouveauRouteImport } from './routes/admin/criteres.nouveau'
import { Route as AdminCriteresCriterionIdRouteImport } from './routes/admin/criteres.$criterionId'
import { Route as AdminSessionsSessionIdRelectureRouteImport } from './routes/admin/sessions.$sessionId_.relecture'
import { Route as AdminSessionsSessionIdProtocoleRouteImport } from './routes/admin/sessions.$sessionId_.protocole'
import { Route as AdminExperiencesExperienceIdPagesPageIdRouteImport } from './routes/admin/experiences.$experienceId_.pages.$pageId'

const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LSecretRoute = LSecretRouteImport.update({
  id: '/l/$secret',
  path: '/l/$secret',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatTokenRoute = ChatTokenRouteImport.update({
  id: '/chat/$token',
  path: '/chat/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReglagesRoute = AdminReglagesRouteImport.update({
  id: '/reglages',
  path: '/reglages',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProdRoute = AdminProdRouteImport.update({
  id: '/prod',
  path: '/prod',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMediathequeRoute = AdminMediathequeRouteImport.update({
  id: '/mediatheque',
  path: '/mediatheque',
  getParentRoute: () => AdminRoute,
} as any)
const AdminJournalRoute = AdminJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSessionsIndexRoute = AdminSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReglagesIndexRoute = AdminReglagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminProtocolesIndexRoute = AdminProtocolesIndexRouteImport.update({
  id: '/protocoles/',
  path: '/protocoles/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPersonasIndexRoute = AdminPersonasIndexRouteImport.update({
  id: '/personas/',
  path: '/personas/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExperiencesIndexRoute = AdminExperiencesIndexRouteImport.update({
  id: '/experiences/',
  path: '/experiences/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEntretiensIndexRoute = AdminEntretiensIndexRouteImport.update({
  id: '/entretiens/',
  path: '/entretiens/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCriteresIndexRoute = AdminCriteresIndexRouteImport.update({
  id: '/criteres/',
  path: '/criteres/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSessionsSessionIdRoute = AdminSessionsSessionIdRouteImport.update({
  id: '/sessions/$sessionId',
  path: '/sessions/$sessionId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReglagesRejeuRoute = AdminReglagesRejeuRouteImport.update({
  id: '/rejeu',
  path: '/rejeu',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminReglagesReglesRoute = AdminReglagesReglesRouteImport.update({
  id: '/regles',
  path: '/regles',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminReglagesPersonasRoute = AdminReglagesPersonasRouteImport.update({
  id: '/personas',
  path: '/personas',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminReglagesPartageRoute = AdminReglagesPartageRouteImport.update({
  id: '/partage',
  path: '/partage',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminReglagesNoyauxRoute = AdminReglagesNoyauxRouteImport.update({
  id: '/noyaux',
  path: '/noyaux',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminReglagesModelesRoute = AdminReglagesModelesRouteImport.update({
  id: '/modeles',
  path: '/modeles',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminReglagesMethodeRoute = AdminReglagesMethodeRouteImport.update({
  id: '/methode',
  path: '/methode',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminReglagesJetonsRoute = AdminReglagesJetonsRouteImport.update({
  id: '/jetons',
  path: '/jetons',
  getParentRoute: () => AdminReglagesRoute,
} as any)
const AdminProtocolesNouveauRoute = AdminProtocolesNouveauRouteImport.update({
  id: '/protocoles/nouveau',
  path: '/protocoles/nouveau',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProtocolesProtocolIdRoute =
  AdminProtocolesProtocolIdRouteImport.update({
    id: '/protocoles/$protocolId',
    path: '/protocoles/$protocolId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPersonasNouveauRoute = AdminPersonasNouveauRouteImport.update({
  id: '/personas/nouveau',
  path: '/personas/nouveau',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPersonasPersonaIdRoute = AdminPersonasPersonaIdRouteImport.update({
  id: '/personas/$personaId',
  path: '/personas/$personaId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExperiencesNouveauRoute = AdminExperiencesNouveauRouteImport.update({
  id: '/experiences/nouveau',
  path: '/experiences/nouveau',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExperiencesExperienceIdRoute =
  AdminExperiencesExperienceIdRouteImport.update({
    id: '/experiences/$experienceId',
    path: '/experiences/$experienceId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminEntretiensRoomIdRoute = AdminEntretiensRoomIdRouteImport.update({
  id: '/entretiens/$roomId',
  path: '/entretiens/$roomId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCriteresNouveauRoute = AdminCriteresNouveauRouteImport.update({
  id: '/criteres/nouveau',
  path: '/criteres/nouveau',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCriteresCriterionIdRoute =
  AdminCriteresCriterionIdRouteImport.update({
    id: '/criteres/$criterionId',
    path: '/criteres/$criterionId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSessionsSessionIdRelectureRoute =
  AdminSessionsSessionIdRelectureRouteImport.update({
    id: '/sessions/$sessionId_/relecture',
    path: '/sessions/$sessionId/relecture',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminSessionsSessionIdProtocoleRoute =
  AdminSessionsSessionIdProtocoleRouteImport.update({
    id: '/sessions/$sessionId_/protocole',
    path: '/sessions/$sessionId/protocole',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminExperiencesExperienceIdPagesPageIdRoute =
  AdminExperiencesExperienceIdPagesPageIdRouteImport.update({
    id: '/experiences/$experienceId_/pages/$pageId',
    path: '/experiences/$experienceId/pages/$pageId',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin/journal': typeof AdminJournalRoute
  '/admin/mediatheque': typeof AdminMediathequeRoute
  '/admin/prod': typeof AdminProdRoute
  '/admin/reglages': typeof AdminReglagesRouteWithChildren
  '/chat/$token': typeof ChatTokenRoute
  '/l/$secret': typeof LSecretRoute
  '/s/$token': typeof STokenRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/criteres/$criterionId': typeof AdminCriteresCriterionIdRoute
  '/admin/criteres/nouveau': typeof AdminCriteresNouveauRoute
  '/admin/entretiens/$roomId': typeof AdminEntretiensRoomIdRoute
  '/admin/experiences/$experienceId': typeof AdminExperiencesExperienceIdRoute
  '/admin/experiences/nouveau': typeof AdminExperiencesNouveauRoute
  '/admin/personas/$personaId': typeof AdminPersonasPersonaIdRoute
  '/admin/personas/nouveau': typeof AdminPersonasNouveauRoute
  '/admin/protocoles/$protocolId': typeof AdminProtocolesProtocolIdRoute
  '/admin/protocoles/nouveau': typeof AdminProtocolesNouveauRoute
  '/admin/reglages/jetons': typeof AdminReglagesJetonsRoute
  '/admin/reglages/methode': typeof AdminReglagesMethodeRoute
  '/admin/reglages/modeles': typeof AdminReglagesModelesRoute
  '/admin/reglages/noyaux': typeof AdminReglagesNoyauxRoute
  '/admin/reglages/partage': typeof AdminReglagesPartageRoute
  '/admin/reglages/personas': typeof AdminReglagesPersonasRoute
  '/admin/reglages/regles': typeof AdminReglagesReglesRoute
  '/admin/reglages/rejeu': typeof AdminReglagesRejeuRoute
  '/admin/sessions/$sessionId': typeof AdminSessionsSessionIdRoute
  '/admin/criteres/': typeof AdminCriteresIndexRoute
  '/admin/entretiens/': typeof AdminEntretiensIndexRoute
  '/admin/experiences/': typeof AdminExperiencesIndexRoute
  '/admin/personas/': typeof AdminPersonasIndexRoute
  '/admin/protocoles/': typeof AdminProtocolesIndexRoute
  '/admin/reglages/': typeof AdminReglagesIndexRoute
  '/admin/sessions/': typeof AdminSessionsIndexRoute
  '/admin/sessions/$sessionId/protocole': typeof AdminSessionsSessionIdProtocoleRoute
  '/admin/sessions/$sessionId/relecture': typeof AdminSessionsSessionIdRelectureRoute
  '/admin/experiences/$experienceId/pages/$pageId': typeof AdminExperiencesExperienceIdPagesPageIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/journal': typeof AdminJournalRoute
  '/admin/mediatheque': typeof AdminMediathequeRoute
  '/admin/prod': typeof AdminProdRoute
  '/chat/$token': typeof ChatTokenRoute
  '/l/$secret': typeof LSecretRoute
  '/s/$token': typeof STokenRoute
  '/admin': typeof AdminIndexRoute
  '/admin/criteres/$criterionId': typeof AdminCriteresCriterionIdRoute
  '/admin/criteres/nouveau': typeof AdminCriteresNouveauRoute
  '/admin/entretiens/$roomId': typeof AdminEntretiensRoomIdRoute
  '/admin/experiences/$experienceId': typeof AdminExperiencesExperienceIdRoute
  '/admin/experiences/nouveau': typeof AdminExperiencesNouveauRoute
  '/admin/personas/$personaId': typeof AdminPersonasPersonaIdRoute
  '/admin/personas/nouveau': typeof AdminPersonasNouveauRoute
  '/admin/protocoles/$protocolId': typeof AdminProtocolesProtocolIdRoute
  '/admin/protocoles/nouveau': typeof AdminProtocolesNouveauRoute
  '/admin/reglages/jetons': typeof AdminReglagesJetonsRoute
  '/admin/reglages/methode': typeof AdminReglagesMethodeRoute
  '/admin/reglages/modeles': typeof AdminReglagesModelesRoute
  '/admin/reglages/noyaux': typeof AdminReglagesNoyauxRoute
  '/admin/reglages/partage': typeof AdminReglagesPartageRoute
  '/admin/reglages/personas': typeof AdminReglagesPersonasRoute
  '/admin/reglages/regles': typeof AdminReglagesReglesRoute
  '/admin/reglages/rejeu': typeof AdminReglagesRejeuRoute
  '/admin/sessions/$sessionId': typeof AdminSessionsSessionIdRoute
  '/admin/criteres': typeof AdminCriteresIndexRoute
  '/admin/entretiens': typeof AdminEntretiensIndexRoute
  '/admin/experiences': typeof AdminExperiencesIndexRoute
  '/admin/personas': typeof AdminPersonasIndexRoute
  '/admin/protocoles': typeof AdminProtocolesIndexRoute
  '/admin/reglages': typeof AdminReglagesIndexRoute
  '/admin/sessions': typeof AdminSessionsIndexRoute
  '/admin/sessions/$sessionId/protocole': typeof AdminSessionsSessionIdProtocoleRoute
  '/admin/sessions/$sessionId/relecture': typeof AdminSessionsSessionIdRelectureRoute
  '/admin/experiences/$experienceId/pages/$pageId': typeof AdminExperiencesExperienceIdPagesPageIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/admin/journal': typeof AdminJournalRoute
  '/admin/mediatheque': typeof AdminMediathequeRoute
  '/admin/prod': typeof AdminProdRoute
  '/admin/reglages': typeof AdminReglagesRouteWithChildren
  '/chat/$token': typeof ChatTokenRoute
  '/l/$secret': typeof LSecretRoute
  '/s/$token': typeof STokenRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/criteres/$criterionId': typeof AdminCriteresCriterionIdRoute
  '/admin/criteres/nouveau': typeof AdminCriteresNouveauRoute
  '/admin/entretiens/$roomId': typeof AdminEntretiensRoomIdRoute
  '/admin/experiences/$experienceId': typeof AdminExperiencesExperienceIdRoute
  '/admin/experiences/nouveau': typeof AdminExperiencesNouveauRoute
  '/admin/personas/$personaId': typeof AdminPersonasPersonaIdRoute
  '/admin/personas/nouveau': typeof AdminPersonasNouveauRoute
  '/admin/protocoles/$protocolId': typeof AdminProtocolesProtocolIdRoute
  '/admin/protocoles/nouveau': typeof AdminProtocolesNouveauRoute
  '/admin/reglages/jetons': typeof AdminReglagesJetonsRoute
  '/admin/reglages/methode': typeof AdminReglagesMethodeRoute
  '/admin/reglages/modeles': typeof AdminReglagesModelesRoute
  '/admin/reglages/noyaux': typeof AdminReglagesNoyauxRoute
  '/admin/reglages/partage': typeof AdminReglagesPartageRoute
  '/admin/reglages/personas': typeof AdminReglagesPersonasRoute
  '/admin/reglages/regles': typeof AdminReglagesReglesRoute
  '/admin/reglages/rejeu': typeof AdminReglagesRejeuRoute
  '/admin/sessions/$sessionId': typeof AdminSessionsSessionIdRoute
  '/admin/criteres/': typeof AdminCriteresIndexRoute
  '/admin/entretiens/': typeof AdminEntretiensIndexRoute
  '/admin/experiences/': typeof AdminExperiencesIndexRoute
  '/admin/personas/': typeof AdminPersonasIndexRoute
  '/admin/protocoles/': typeof AdminProtocolesIndexRoute
  '/admin/reglages/': typeof AdminReglagesIndexRoute
  '/admin/sessions/': typeof AdminSessionsIndexRoute
  '/admin/sessions/$sessionId_/protocole': typeof AdminSessionsSessionIdProtocoleRoute
  '/admin/sessions/$sessionId_/relecture': typeof AdminSessionsSessionIdRelectureRoute
  '/admin/experiences/$experienceId_/pages/$pageId': typeof AdminExperiencesExperienceIdPagesPageIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/admin/journal'
    | '/admin/mediatheque'
    | '/admin/prod'
    | '/admin/reglages'
    | '/chat/$token'
    | '/l/$secret'
    | '/s/$token'
    | '/admin/'
    | '/admin/criteres/$criterionId'
    | '/admin/criteres/nouveau'
    | '/admin/entretiens/$roomId'
    | '/admin/experiences/$experienceId'
    | '/admin/experiences/nouveau'
    | '/admin/personas/$personaId'
    | '/admin/personas/nouveau'
    | '/admin/protocoles/$protocolId'
    | '/admin/protocoles/nouveau'
    | '/admin/reglages/jetons'
    | '/admin/reglages/methode'
    | '/admin/reglages/modeles'
    | '/admin/reglages/noyaux'
    | '/admin/reglages/partage'
    | '/admin/reglages/personas'
    | '/admin/reglages/regles'
    | '/admin/reglages/rejeu'
    | '/admin/sessions/$sessionId'
    | '/admin/criteres/'
    | '/admin/entretiens/'
    | '/admin/experiences/'
    | '/admin/personas/'
    | '/admin/protocoles/'
    | '/admin/reglages/'
    | '/admin/sessions/'
    | '/admin/sessions/$sessionId/protocole'
    | '/admin/sessions/$sessionId/relecture'
    | '/admin/experiences/$experienceId/pages/$pageId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/journal'
    | '/admin/mediatheque'
    | '/admin/prod'
    | '/chat/$token'
    | '/l/$secret'
    | '/s/$token'
    | '/admin'
    | '/admin/criteres/$criterionId'
    | '/admin/criteres/nouveau'
    | '/admin/entretiens/$roomId'
    | '/admin/experiences/$experienceId'
    | '/admin/experiences/nouveau'
    | '/admin/personas/$personaId'
    | '/admin/personas/nouveau'
    | '/admin/protocoles/$protocolId'
    | '/admin/protocoles/nouveau'
    | '/admin/reglages/jetons'
    | '/admin/reglages/methode'
    | '/admin/reglages/modeles'
    | '/admin/reglages/noyaux'
    | '/admin/reglages/partage'
    | '/admin/reglages/personas'
    | '/admin/reglages/regles'
    | '/admin/reglages/rejeu'
    | '/admin/sessions/$sessionId'
    | '/admin/criteres'
    | '/admin/entretiens'
    | '/admin/experiences'
    | '/admin/personas'
    | '/admin/protocoles'
    | '/admin/reglages'
    | '/admin/sessions'
    | '/admin/sessions/$sessionId/protocole'
    | '/admin/sessions/$sessionId/relecture'
    | '/admin/experiences/$experienceId/pages/$pageId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/admin/journal'
    | '/admin/mediatheque'
    | '/admin/prod'
    | '/admin/reglages'
    | '/chat/$token'
    | '/l/$secret'
    | '/s/$token'
    | '/admin/'
    | '/admin/criteres/$criterionId'
    | '/admin/criteres/nouveau'
    | '/admin/entretiens/$roomId'
    | '/admin/experiences/$experienceId'
    | '/admin/experiences/nouveau'
    | '/admin/personas/$personaId'
    | '/admin/personas/nouveau'
    | '/admin/protocoles/$protocolId'
    | '/admin/protocoles/nouveau'
    | '/admin/reglages/jetons'
    | '/admin/reglages/methode'
    | '/admin/reglages/modeles'
    | '/admin/reglages/noyaux'
    | '/admin/reglages/partage'
    | '/admin/reglages/personas'
    | '/admin/reglages/regles'
    | '/admin/reglages/rejeu'
    | '/admin/sessions/$sessionId'
    | '/admin/criteres/'
    | '/admin/entretiens/'
    | '/admin/experiences/'
    | '/admin/personas/'
    | '/admin/protocoles/'
    | '/admin/reglages/'
    | '/admin/sessions/'
    | '/admin/sessions/$sessionId_/protocole'
    | '/admin/sessions/$sessionId_/relecture'
    | '/admin/experiences/$experienceId_/pages/$pageId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  ChatTokenRoute: typeof ChatTokenRoute
  LSecretRoute: typeof LSecretRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$secret': {
      id: '/l/$secret'
      path: '/l/$secret'
      fullPath: '/l/$secret'
      preLoaderRoute: typeof LSecretRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/$token': {
      id: '/chat/$token'
      path: '/chat/$token'
      fullPath: '/chat/$token'
      preLoaderRoute: typeof ChatTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reglages': {
      id: '/admin/reglages'
      path: '/reglages'
      fullPath: '/admin/reglages'
      preLoaderRoute: typeof AdminReglagesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/prod': {
      id: '/admin/prod'
      path: '/prod'
      fullPath: '/admin/prod'
      preLoaderRoute: typeof AdminProdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/mediatheque': {
      id: '/admin/mediatheque'
      path: '/mediatheque'
      fullPath: '/admin/mediatheque'
      preLoaderRoute: typeof AdminMediathequeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/journal': {
      id: '/admin/journal'
      path: '/journal'
      fullPath: '/admin/journal'
      preLoaderRoute: typeof AdminJournalRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sessions/': {
      id: '/admin/sessions/'
      path: '/sessions'
      fullPath: '/admin/sessions/'
      preLoaderRoute: typeof AdminSessionsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reglages/': {
      id: '/admin/reglages/'
      path: '/'
      fullPath: '/admin/reglages/'
      preLoaderRoute: typeof AdminReglagesIndexRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/protocoles/': {
      id: '/admin/protocoles/'
      path: '/protocoles'
      fullPath: '/admin/protocoles/'
      preLoaderRoute: typeof AdminProtocolesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/personas/': {
      id: '/admin/personas/'
      path: '/personas'
      fullPath: '/admin/personas/'
      preLoaderRoute: typeof AdminPersonasIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/experiences/': {
      id: '/admin/experiences/'
      path: '/experiences'
      fullPath: '/admin/experiences/'
      preLoaderRoute: typeof AdminExperiencesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/entretiens/': {
      id: '/admin/entretiens/'
      path: '/entretiens'
      fullPath: '/admin/entretiens/'
      preLoaderRoute: typeof AdminEntretiensIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/criteres/': {
      id: '/admin/criteres/'
      path: '/criteres'
      fullPath: '/admin/criteres/'
      preLoaderRoute: typeof AdminCriteresIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sessions/$sessionId': {
      id: '/admin/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/admin/sessions/$sessionId'
      preLoaderRoute: typeof AdminSessionsSessionIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reglages/rejeu': {
      id: '/admin/reglages/rejeu'
      path: '/rejeu'
      fullPath: '/admin/reglages/rejeu'
      preLoaderRoute: typeof AdminReglagesRejeuRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/reglages/regles': {
      id: '/admin/reglages/regles'
      path: '/regles'
      fullPath: '/admin/reglages/regles'
      preLoaderRoute: typeof AdminReglagesReglesRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/reglages/personas': {
      id: '/admin/reglages/personas'
      path: '/personas'
      fullPath: '/admin/reglages/personas'
      preLoaderRoute: typeof AdminReglagesPersonasRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/reglages/partage': {
      id: '/admin/reglages/partage'
      path: '/partage'
      fullPath: '/admin/reglages/partage'
      preLoaderRoute: typeof AdminReglagesPartageRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/reglages/noyaux': {
      id: '/admin/reglages/noyaux'
      path: '/noyaux'
      fullPath: '/admin/reglages/noyaux'
      preLoaderRoute: typeof AdminReglagesNoyauxRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/reglages/modeles': {
      id: '/admin/reglages/modeles'
      path: '/modeles'
      fullPath: '/admin/reglages/modeles'
      preLoaderRoute: typeof AdminReglagesModelesRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/reglages/methode': {
      id: '/admin/reglages/methode'
      path: '/methode'
      fullPath: '/admin/reglages/methode'
      preLoaderRoute: typeof AdminReglagesMethodeRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/reglages/jetons': {
      id: '/admin/reglages/jetons'
      path: '/jetons'
      fullPath: '/admin/reglages/jetons'
      preLoaderRoute: typeof AdminReglagesJetonsRouteImport
      parentRoute: typeof AdminReglagesRoute
    }
    '/admin/protocoles/nouveau': {
      id: '/admin/protocoles/nouveau'
      path: '/protocoles/nouveau'
      fullPath: '/admin/protocoles/nouveau'
      preLoaderRoute: typeof AdminProtocolesNouveauRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/protocoles/$protocolId': {
      id: '/admin/protocoles/$protocolId'
      path: '/protocoles/$protocolId'
      fullPath: '/admin/protocoles/$protocolId'
      preLoaderRoute: typeof AdminProtocolesProtocolIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/personas/nouveau': {
      id: '/admin/personas/nouveau'
      path: '/personas/nouveau'
      fullPath: '/admin/personas/nouveau'
      preLoaderRoute: typeof AdminPersonasNouveauRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/personas/$personaId': {
      id: '/admin/personas/$personaId'
      path: '/personas/$personaId'
      fullPath: '/admin/personas/$personaId'
      preLoaderRoute: typeof AdminPersonasPersonaIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/experiences/nouveau': {
      id: '/admin/experiences/nouveau'
      path: '/experiences/nouveau'
      fullPath: '/admin/experiences/nouveau'
      preLoaderRoute: typeof AdminExperiencesNouveauRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/experiences/$experienceId': {
      id: '/admin/experiences/$experienceId'
      path: '/experiences/$experienceId'
      fullPath: '/admin/experiences/$experienceId'
      preLoaderRoute: typeof AdminExperiencesExperienceIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/entretiens/$roomId': {
      id: '/admin/entretiens/$roomId'
      path: '/entretiens/$roomId'
      fullPath: '/admin/entretiens/$roomId'
      preLoaderRoute: typeof AdminEntretiensRoomIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/criteres/nouveau': {
      id: '/admin/criteres/nouveau'
      path: '/criteres/nouveau'
      fullPath: '/admin/criteres/nouveau'
      preLoaderRoute: typeof AdminCriteresNouveauRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/criteres/$criterionId': {
      id: '/admin/criteres/$criterionId'
      path: '/criteres/$criterionId'
      fullPath: '/admin/criteres/$criterionId'
      preLoaderRoute: typeof AdminCriteresCriterionIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sessions/$sessionId_/relecture': {
      id: '/admin/sessions/$sessionId_/relecture'
      path: '/sessions/$sessionId/relecture'
      fullPath: '/admin/sessions/$sessionId/relecture'
      preLoaderRoute: typeof AdminSessionsSessionIdRelectureRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sessions/$sessionId_/protocole': {
      id: '/admin/sessions/$sessionId_/protocole'
      path: '/sessions/$sessionId/protocole'
      fullPath: '/admin/sessions/$sessionId/protocole'
      preLoaderRoute: typeof AdminSessionsSessionIdProtocoleRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/experiences/$experienceId_/pages/$pageId': {
      id: '/admin/experiences/$experienceId_/pages/$pageId'
      path: '/experiences/$experienceId/pages/$pageId'
      fullPath: '/admin/experiences/$experienceId/pages/$pageId'
      preLoaderRoute: typeof AdminExperiencesExperienceIdPagesPageIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminReglagesRouteChildren {
  AdminReglagesJetonsRoute: typeof AdminReglagesJetonsRoute
  AdminReglagesMethodeRoute: typeof AdminReglagesMethodeRoute
  AdminReglagesModelesRoute: typeof AdminReglagesModelesRoute
  AdminReglagesNoyauxRoute: typeof AdminReglagesNoyauxRoute
  AdminReglagesPartageRoute: typeof AdminReglagesPartageRoute
  AdminReglagesPersonasRoute: typeof AdminReglagesPersonasRoute
  AdminReglagesReglesRoute: typeof AdminReglagesReglesRoute
  AdminReglagesRejeuRoute: typeof AdminReglagesRejeuRoute
  AdminReglagesIndexRoute: typeof AdminReglagesIndexRoute
}

const AdminReglagesRouteChildren: AdminReglagesRouteChildren = {
  AdminReglagesJetonsRoute: AdminReglagesJetonsRoute,
  AdminReglagesMethodeRoute: AdminReglagesMethodeRoute,
  AdminReglagesModelesRoute: AdminReglagesModelesRoute,
  AdminReglagesNoyauxRoute: AdminReglagesNoyauxRoute,
  AdminReglagesPartageRoute: AdminReglagesPartageRoute,
  AdminReglagesPersonasRoute: AdminReglagesPersonasRoute,
  AdminReglagesReglesRoute: AdminReglagesReglesRoute,
  AdminReglagesRejeuRoute: AdminReglagesRejeuRoute,
  AdminReglagesIndexRoute: AdminReglagesIndexRoute,
}

const AdminReglagesRouteWithChildren = AdminReglagesRoute._addFileChildren(
  AdminReglagesRouteChildren,
)

interface AdminRouteChildren {
  AdminJournalRoute: typeof AdminJournalRoute
  AdminMediathequeRoute: typeof AdminMediathequeRoute
  AdminProdRoute: typeof AdminProdRoute
  AdminReglagesRoute: typeof AdminReglagesRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCriteresCriterionIdRoute: typeof AdminCriteresCriterionIdRoute
  AdminCriteresNouveauRoute: typeof AdminCriteresNouveauRoute
  AdminEntretiensRoomIdRoute: typeof AdminEntretiensRoomIdRoute
  AdminExperiencesExperienceIdRoute: typeof AdminExperiencesExperienceIdRoute
  AdminExperiencesNouveauRoute: typeof AdminExperiencesNouveauRoute
  AdminPersonasPersonaIdRoute: typeof AdminPersonasPersonaIdRoute
  AdminPersonasNouveauRoute: typeof AdminPersonasNouveauRoute
  AdminProtocolesProtocolIdRoute: typeof AdminProtocolesProtocolIdRoute
  AdminProtocolesNouveauRoute: typeof AdminProtocolesNouveauRoute
  AdminSessionsSessionIdRoute: typeof AdminSessionsSessionIdRoute
  AdminCriteresIndexRoute: typeof AdminCriteresIndexRoute
  AdminEntretiensIndexRoute: typeof AdminEntretiensIndexRoute
  AdminExperiencesIndexRoute: typeof AdminExperiencesIndexRoute
  AdminPersonasIndexRoute: typeof AdminPersonasIndexRoute
  AdminProtocolesIndexRoute: typeof AdminProtocolesIndexRoute
  AdminSessionsIndexRoute: typeof AdminSessionsIndexRoute
  AdminSessionsSessionIdProtocoleRoute: typeof AdminSessionsSessionIdProtocoleRoute
  AdminSessionsSessionIdRelectureRoute: typeof AdminSessionsSessionIdRelectureRoute
  AdminExperiencesExperienceIdPagesPageIdRoute: typeof AdminExperiencesExperienceIdPagesPageIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminJournalRoute: AdminJournalRoute,
  AdminMediathequeRoute: AdminMediathequeRoute,
  AdminProdRoute: AdminProdRoute,
  AdminReglagesRoute: AdminReglagesRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
  AdminCriteresCriterionIdRoute: AdminCriteresCriterionIdRoute,
  AdminCriteresNouveauRoute: AdminCriteresNouveauRoute,
  AdminEntretiensRoomIdRoute: AdminEntretiensRoomIdRoute,
  AdminExperiencesExperienceIdRoute: AdminExperiencesExperienceIdRoute,
  AdminExperiencesNouveauRoute: AdminExperiencesNouveauRoute,
  AdminPersonasPersonaIdRoute: AdminPersonasPersonaIdRoute,
  AdminPersonasNouveauRoute: AdminPersonasNouveauRoute,
  AdminProtocolesProtocolIdRoute: AdminProtocolesProtocolIdRoute,
  AdminProtocolesNouveauRoute: AdminProtocolesNouveauRoute,
  AdminSessionsSessionIdRoute: AdminSessionsSessionIdRoute,
  AdminCriteresIndexRoute: AdminCriteresIndexRoute,
  AdminEntretiensIndexRoute: AdminEntretiensIndexRoute,
  AdminExperiencesIndexRoute: AdminExperiencesIndexRoute,
  AdminPersonasIndexRoute: AdminPersonasIndexRoute,
  AdminProtocolesIndexRoute: AdminProtocolesIndexRoute,
  AdminSessionsIndexRoute: AdminSessionsIndexRoute,
  AdminSessionsSessionIdProtocoleRoute: AdminSessionsSessionIdProtocoleRoute,
  AdminSessionsSessionIdRelectureRoute: AdminSessionsSessionIdRelectureRoute,
  AdminExperiencesExperienceIdPagesPageIdRoute:
    AdminExperiencesExperienceIdPagesPageIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  ChatTokenRoute: ChatTokenRoute,
  LSecretRoute: LSecretRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
